import type { ReactNode } from 'react';

export const symbol_store: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="M190-800h582q12.75 0 21.38 8.68 8.62 8.67 8.62 21.5 0 12.82-8.62 21.32-8.63 8.5-21.38 8.5H190q-12.75 0-21.37-8.68-8.63-8.67-8.63-21.5 0-12.82 8.63-21.32 8.62-8.5 21.37-8.5Zm5 640q-12.75 0-21.37-8.63Q165-177.25 165-190v-228h-25q-14.14 0-23.07-11T111-454l44-202q2-11 10.25-17.5T184-680h593q10.5 0 18.75 6.5T806-656l44 202q3 14-5.93 25T821-418h-25v228q0 12.75-8.68 21.37-8.67 8.63-21.5 8.63-12.82 0-21.32-8.63-8.5-8.62-8.5-21.37v-228H547v228q0 12.75-8.62 21.37Q529.75-160 517-160H195Zm30-60h262v-198H225v198Zm-50-258h611-611Zm0 0h611l-31-142H206l-31 142Z"
		/>
	</svg>
);
